module.exports = __webpack_public_path__ + "static/the-arabian-nights-edd942996a89a334b7a943c4995d39dc.jpg";